import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-note-detail-modal',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule
    ],
    templateUrl: './note-detail-modal.component.html',
})
export class NoteDetailModalComponent {
    readonly dialogRef = inject(MatDialogRef<NoteDetailModalComponent>);
    readonly data = inject(MAT_DIALOG_DATA);

    onClose() {
        this.dialogRef.close();
    }

    materialCode() {
        return this.data?.detail?.material?.externalKeys?.code || this.data?.detail?.material?.code;
    }

    materialName() {
        return this.data?.detail?.material?.name;
    }

    hasNote() {
        return this.data?.detail?.note && this.data.detail.note.trim() !== '';
    }
}